<template>
    <div class="doc-section">
        <h1>Ubicaciones</h1>
        <p>
            Esta sección permite gestionar puntos de interés personalizados en el mapa, facilitando la identificación de
            lugares recurrentes para la operación.
        </p>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />



        <h2>Acceso al Listado</h2>
        <div v-if="plataforma === 'web'" class="platform-content">
            <p>Para visualizar la lista de ubicaciones guardadas creadas en el sistema:</p>
            <ol class="ul-contenedor step-list">
                <li>Hacer clic sobre el botón <strong>Dispositivos y Ubicaciones</strong>.</li>
                <li>Hacer clic sobre la pestaña <strong>Ubicaciones</strong>.</li>
                <li>Se mostrará la pantalla principal con el listado de las ubicaciones registradas.</li>
            </ol>


            <h2>Interfaz de Usuario</h2>
            <ul class="ul-contenedor step-list">
                <li><strong>Tabla:</strong> Cuenta con dos columnas (Nombre de la ubicación y Acciones).</li>
                <li><strong>Acciones disponibles:</strong>
                    <ul style="list-style: none; padding-left: 10px;">
                        <li>a) <strong>Ver:</strong> Localiza el punto en el mapa.</li>
                        <li>b) <strong>Editar:</strong> Modifica los datos del punto.</li>
                        <li>c) <strong>Eliminar:</strong> Borra el registro.</li>
                    </ul>
                </li>
            </ul>


            <h2>Herramientas Globales</h2>
            <ul class="ul-contenedor step-list">
                <li><strong>Botón Agregar ubicación:</strong> Permite registrar una nueva ubicación.</li>
                <li><strong>Botón Mostrar ubicaciones:</strong> Permite visualizar en el mapa todas las ubicaciones
                    registradas simultáneamente.</li>
            </ul>



            <p><strong>Niveles de Acceso:</strong></p>
            <ul class="ul-contenedor step-list" style="list-style-type: lower-alpha;">
                <li>El <strong>Administrador</strong> podrá visualizar todas las ubicaciones registradas por todos los
                    usuarios.</li>
                <li>El <strong>Usuario final</strong> únicamente puede visualizar las ubicaciones que él mismo ha
                    registrado.</li>
            </ul>

            <h3>Referencia Visual</h3>
            <CarruselAciqui :items="imagenesUbicaciones" />
        </div>

        <div v-if="plataforma === 'moviles'" class="platform-content">
            <p>Para visualizar la lista de ubicaciones guardadas creadas en el sistema:</p>
            <ol class="ul-contenedor step-list">
                <li>Hacer clic sobre el botón <strong>Dispositivos y Ubicaciones</strong>.
                    <CarruselAciqui :items="[imagenesUbicacionesMoviles[0]]" />
                </li>

                <li>Hacer clic sobre la pestaña <strong>Ubicaciones</strong>.
                    <CarruselAciqui :items="[imagenesUbicacionesMoviles[1]]" />
                </li>
                <li>Se mostrará la pantalla principal con el listado de las ubicaciones registradas.
                    <CarruselAciqui :items="[imagenesUbicacionesMoviles[2]]" />
                </li>
            </ol>


            <h2>Tabla de ubicaciones</h2>
            <ul class="ul-contenedor step-list">
                <li><strong>Tabla:</strong> Cuenta con dos columnas (Nombre de la ubicación y Acciones).</li>
                <li><strong>Acciones disponibles:</strong>
                    <ul style="list-style: none; padding-left: 10px;">
                        <li>a) <strong>Ver:</strong> Localiza el punto en el mapa.</li>
                        <li>b) <strong>Editar:</strong> Modifica los datos del punto.</li>
                        <li>c) <strong>Eliminar:</strong> Borra el registro.</li>
                    </ul>
                </li>
            </ul>

            <CarruselAciqui :items="[imagenesUbicacionesMoviles[3]]" />


            <h2>Herramientas Globales</h2>
            <ul class="ul-contenedor step-list">
                <li><strong>Botón Agregar ubicación:</strong> Permite registrar una nueva ubicación.</li>
                <li><strong>Botón Mostrar ubicaciones:</strong> Permite visualizar en el mapa todas las ubicaciones
                    registradas simultáneamente.</li>
            </ul>



            <p><strong>Niveles de Acceso:</strong></p>
            <ul class="ul-contenedor step-list">
                <li>El <strong>Administrador</strong> podrá visualizar todas las ubicaciones registradas por todos los
                    usuarios.</li>
                <li>El <strong>Usuario final</strong> únicamente puede visualizar las ubicaciones que él mismo ha
                    registrado.</li>
            </ul>
            <CarruselAciqui :items="[imagenesUbicacionesMoviles[4]]" />
        </div>


    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'UbicacionesManuales',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesUbicaciones: [
            {
                nombre: "Lista de Ubicaciones",
                url: "img/ubicaciones/listadoUbicaciones.png",
                descripcion: "Vista de la pestaña de ubicaciones con tabla de gestión."
            }
        ],

        imagenesUbicacionesMoviles: [
            {
                nombre: "",
                url: "img/ubicaciones/moviles/btn_disp_ubicaciones.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/ubicaciones/moviles/btn_ubicaciones.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/ubicaciones/moviles/listado_ubicaciones_reg.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/ubicaciones/moviles/acciones_tabla_ubicaciones.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/ubicaciones/moviles/acciones_globales.png",
                descripcion: ""
            },
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }


}
</script>